import FileSaver from 'file-saver'

export default {
  saveBlobToFile(data: any, fileName: string) {
    FileSaver.saveAs(new Blob([data]), fileName)
  },
}
